import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

let galleryBlocks = document.querySelectorAll(".component__post-gallery");
const lightbox = new PhotoSwipeLightbox({
    gallery: galleryBlocks,
    children: "a",
    showHideAnimationType: "fade",
    pswpModule: () => import("photoswipe"),
    imageClickAction: "close",
    tapAction: "close",
});

document.querySelectorAll(".component__post-gallery").forEach((gallery) => {
    const columns = gallery.dataset.columns;
    gallery.style.setProperty("--columns", columns);
});

lightbox.init();
